/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/prop-types */
/**
 * @author Shalini
 * @name HeaderComponent
 * @desc Composable header component
 */
import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import style from './Header.module.css';
import BulkUpload from '../../BulkUpload';
import { CustomToolTip } from '../../ToolTips';
import { HeaderComponentStyles } from './HeaderComponentStyles';
import NotificationBadge from '../../Notification/NotificationBadge';
import NOTIFICATION_CONFIG from '../../Notification/config';
import ErrorHandler from '../../ErrorHandler';
import LeftNavigation2 from '../../LeftNavigation2';
import QuickTour from '../../QuickTour';
import { getModulesFromAbbreviations } from '../../coreUtility';
import { MaterialUiCore, MaterialUiIcons } from '@gscope-mfe/common-libs';
import { AppUtils, Services, Utilities } from '@gscope-mfe/app-bridge';
import { useTranslation } from 'react-i18next';
import StrideNavigation from '../../StrideNavigation/component/StrideNavigation';
const { Toolbar } = MaterialUiCore,
    { Typography } = MaterialUiCore,
    { withStyles } = MaterialUiCore,
    { Button, makeStyles, Menu, MenuItem } = MaterialUiCore,
    { ExpandMore, ExpandLess } = MaterialUiIcons,
    { bulkUploadHistory, getBUMartID, getIssueCollectorEnvSupport } = Services,
    { setUserPreference, cookies } = Utilities;
const useStyles = makeStyles({
    requestAccessButton: {
        marginRight: '15px',
        '& .MuiButton-textPrimary': {
            color: '#000',
            border: '1px solid black',
            borderRadius: '15px',
            height: '34px !important',
            fontWeight: 'bold',
        },
        '& .MuiButton-label': {
            textTransform: 'none',
        },
    },
});
const HeaderComponent = ({ classes, userPref, toggleIssueReporter }) => {
    const customClass = useStyles();
    const { title, children, hideHeader, hideNavigation, showHelpDocs, showQuickTour } = AppUtils.get().headerConfig;
    const {
        currentMarket,
        currentPageFAQ,
        userInfo,
        setMarketConfig,
        notificationPreferences,
        notificationConfig,
        bucketsLookup,
        currentPageKey,
        currentPage,
        setloading,
        setUserPref,
        issueCollector,
        setHeaderConfig,
        headerConfig,
    } = AppUtils.get();
    const { t } = useTranslation('commonLang');
    const wrapperRef = React.useRef(null);
    const { bulkActions, serviceAction, serviceType, hasEditPermission, showTIDcolumn } =
        AppUtils.get().bulkUploadConfig;
    const [openBulkUploadDrawer, setOpenBulkUploadDrawer] = React.useState(false);
    const [uploadHistory, setUploadHistory] = React.useState([]);
    const [pinnedBuckets, setPinnedBuckets] = React.useState([]);
    const [pinnedModules, setPinnedModules] = React.useState([]);
    const [issueCollectorEnvSupport, setIssueCollectorEnvSupport] = React.useState(false);
    const [windowWidth, setWindowWidth] = React.useState(window.innerWidth);
    const [bucketsLookupWithPin, setBucketsLookupWithPin] = React.useState(bucketsLookup);
    const [onLoadPinUnpinAction, setOnLoadPinUnpinAction] = React.useState(true);
    const [supportMenuItems, setSupportMenuItems] = React.useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [startQuickTour, setStartQuickTour] = React.useState(false);
    const missingModulesPaths = [];
    const checkIssueCollectorEnvSupport = async () => {
        try {
            const { data } = await getIssueCollectorEnvSupport();
            setIssueCollectorEnvSupport(data);
        } catch (error) {
            setIssueCollectorEnvSupport(false);
        }
    };
    const updateUploadHistory = async (newTransactionIds = []) => {
        const { data } = await bulkUploadHistory(userInfo.loggedInUserName);
        if (data.payload) {
            setUploadHistory(data.payload.history);
            if (newTransactionIds.length) {
                const recentUploadedFiles = data.payload.history.filter((h) =>
                    newTransactionIds.includes(h.transactionId),
                );
                const lastUploadTime = parseInt(global.localStorage.lastUploadTime || -1, 10);
                const currentUploadTime =
                    recentUploadedFiles.length > 0
                        ? recentUploadedFiles[recentUploadedFiles.length - 1].uploadDate
                        : -1;
                Object.assign(global.localStorage, {
                    lastUploadTime: lastUploadTime === -1 ? currentUploadTime : lastUploadTime,
                });
            }
        }
    };
    const hideBulkUpload = () => {
        // clearInterval(bulkGlobals.intervalId);
        setOpenBulkUploadDrawer(false);
    };
    const showBulkUpload = () => {
        updateUploadHistory();
        // bulkGlobals.intervalId = setInterval(updateUploadHistory, 15000);
        setOpenBulkUploadDrawer(true);
    };

    /**
     * @name fetchBUMartID
     * @desc gets the BU and Mart ID for current market
     */
    const fetchBUMartID = async () => {
        const { data } = await getBUMartID(currentMarket, userInfo.loggedInUserName);
        if (data && data.marketConfig) {
            try {
                const marketConf = JSON.parse(data.marketConfig);
                setMarketConfig({
                    buId: marketConf.buId,
                    martId: marketConf.martId,
                });
            } catch (e) {
                console.log(e);
            }
        }
    };
    const respondToWidthChange = () => {
        let copyHeader = {
            ...headerConfig,
            showLeftNavMobile: false,
            showLeftPanel: false,
            windowWidth: window.innerWidth,
        };
        setHeaderConfig(copyHeader);
        setWindowWidth(window.innerWidth);
    };
    React.useEffect(() => {
        checkIssueCollectorEnvSupport();
        fetchBUMartID();
    }, []);
    React.useEffect(() => {
        const supportItems = {};
        if (issueCollectorEnvSupport && issueCollector) supportItems['reportIssue'] = true;
        if (showHelpDocs) supportItems['helpDocs'] = true;
        if (showQuickTour) supportItems['quickTour'] = true;
        setSupportMenuItems(supportItems);
    }, [issueCollectorEnvSupport, issueCollector, showHelpDocs]);
    React.useEffect(() => {
        fetchBUMartID();
    }, [currentMarket]);
    React.useEffect(() => {
        window.addEventListener('resize', respondToWidthChange);
        return () => {
            window.removeEventListener('resize', respondToWidthChange);
        };
    }, [headerConfig]);
    React.useEffect(() => {
        if (bucketsLookup && Object.keys(bucketsLookup).length > 0) getPinnedModules();
    }, [bucketsLookup]);
    const redirectToConfluenceLink = () => window.open(currentPageFAQ);
    const hasBulkActions = (serviceAction && serviceType) || (bulkActions && Object.keys(bulkActions).length > 0);
    const modsWithNotifications = [];
    if (hasBulkActions && userInfo) {
        modsWithNotifications.push(
            NOTIFICATION_CONFIG.mods.bulkUpload({
                userName: userInfo.loggedInUserName,
            }),
        );
    }
    const notificationsEnabled =
        userInfo &&
        notificationConfig &&
        notificationPreferences &&
        (notificationConfig.enabledUsers.includes('*') ||
            notificationConfig.enabledUsers.includes(userInfo.loggedInUserName));
    const hasNotificationBadge = modsWithNotifications.length > 0 && notificationsEnabled;
    const compareAllPathsAndPinnedBucket = (AllPathsAvailable, prefTobeAdded, buckets, bucketsToExplore, itr) => {
        Object.keys(buckets[bucketsToExplore[itr]]['pages']).map((pg) => {
            if (itr < bucketToExplore.length) {
                if (!AllPathsAvailable.includes(buckets[bucketToExplore[itr]]['pages'][pg].pinPath)) {
                    // AllPathsAvailable.push(buckets[bucketToExplore[itr]]["pages"][pg].pinPath);
                    prefTobeAdded.push(buckets[bucketToExplore[itr]]['pages'][pg].pinPath);
                }
                if (Object.hasOwnProperty(buckets[bucketsToExplore[itr]]['pages'][pg], 'pages')) {
                    prefTobeAdded = compareAllPathsAndPinnedBucket(
                        AllPathsAvailable,
                        prefToBeAdded,
                        buckets[bucketsToExplore[itr]]['pages'][pg],
                        bucketsToExplore,
                        itr++,
                    );
                }

                //itr++;
            }

            return prefTobeAdded;
        });
    };
    const compareAllPathsWithExactBucketAndPinTheMissing = (AllPathsAvailable, exactBucket) => {
        if (exactBucket) {
            Object.keys(exactBucket['pages']).map((pg) => {
                if (!AllPathsAvailable.includes(exactBucket['pages'][pg].pinPath)) {
                    let bucket = exactBucket['pages'][pg];
                    let pageKey = bucket.pinPath;
                    let preferences = localStorage.getItem(`ngStorage-preferences_${userInfo.loggedInUserName}`);
                    preferences = preferences ? JSON.parse(preferences) : {};
                    let pinnedModules = preferences.appHome ? preferences.appHome.pinnedModules || {} : {};
                    let pinnedModulesForMarket = pinnedModules[userInfo.currentMarket] || [];
                    const index = pinnedModulesForMarket.findIndex((page) => page === pageKey);
                    if (index == -1) {
                        pinnedModulesForMarket.push(pageKey);
                        pinnedModules[userInfo.currentMarket] = pinnedModulesForMarket;
                        setloading(true);
                        setUserPreference({
                            pageName: 'appHome',
                            key: 'pinnedModules',
                            value: pinnedModules,
                        })
                            .then((res) => {
                                let preferences = localStorage.getItem(
                                    `ngStorage-preferences_${userInfo.loggedInUserName}`,
                                );
                                preferences = preferences ? JSON.parse(preferences) : {};
                                const pinnedModules = preferences.appHome
                                    ? preferences.appHome.pinnedModules || {}
                                    : {};
                                const pinnedModulesForMarket = pinnedModules[userInfo.currentMarket] || [];
                                const pageDetails = getModulesFromAbbreviations(pinnedModulesForMarket, bucketsLookup);
                                setPinnedBuckets(pageDetails);
                                setPinnedModules(pinnedModulesForMarket);
                                triggerUserPrefChange();
                            })
                            .finally(() => setloading(false));
                    }
                }
                if (Object.hasOwnProperty(pg, 'pages')) {
                    compareAllPathsWithExactBucketAndPinTheMissing(exactBucket['pages'].pg);
                }
            });
        }
    };
    const getPinnedModules = () => {
        let preferences = localStorage.getItem(`ngStorage-preferences_${userInfo.loggedInUserName}`);
        preferences = preferences ? JSON.parse(preferences) : {};
        let pinnedModules = preferences.appHome ? preferences.appHome.pinnedModules || {} : {};
        let pinnedModulesForMarket = pinnedModules[userInfo.currentMarket] || [];
        let bucketsLookupCpLocal = JSON.parse(JSON.stringify(bucketsLookup));
        let pageDetails = getModulesFromAbbreviations(pinnedModulesForMarket, bucketsLookupCpLocal);
        if (bucketsLookupCpLocal && Object.keys(bucketsLookupCpLocal).length > 0 && pinnedModulesForMarket)
            setBucketsWithPinningInfo(bucketsLookupCpLocal, pinnedModulesForMarket);

        //setPreference for the newly added page of a pinned bucket
        if (missingModulesPaths.length > 0) {
            for (let i = 0; i < missingModulesPaths.length; i++) pinnedModulesForMarket.push(missingModulesPaths[i]);
            pinnedModules[userInfo.currentMarket] = pinnedModulesForMarket;
            setloading(true);
            setUserPreference({
                pageName: 'appHome',
                key: 'pinnedModules',
                value: pinnedModules,
            })
                .then((res) => {
                    preferences = localStorage.getItem(`ngStorage-preferences_${userInfo.loggedInUserName}`);
                    preferences = preferences ? JSON.parse(preferences) : {};
                    pinnedModules = preferences.appHome ? preferences.appHome.pinnedModules || {} : {};
                    pinnedModulesForMarket = pinnedModules[userInfo.currentMarket] || [];
                    pageDetails = getModulesFromAbbreviations(pinnedModulesForMarket, bucketsLookup);
                    triggerUserPrefChange();
                })
                .finally(() => setloading(false));
        }
        setPinnedBuckets(pageDetails);
        setPinnedModules(pinnedModulesForMarket);
    };

    //Function to set pinned value to true or false on each bucket and its modules of BucketsLoopWithPinCp
    const setBoolPinnedForBuckets = (pinnedModules, AllBucketsWithPinPathCp) => {
        Object.keys(AllBucketsWithPinPathCp).map((bucket) => {
            //checking for the buckets
            if (pinnedModules.indexOf(AllBucketsWithPinPathCp[bucket].pinPath) > -1) {
                AllBucketsWithPinPathCp[bucket].pinned = true;
            }
            if (Object.prototype.hasOwnProperty.call(AllBucketsWithPinPathCp[bucket], 'pages')) {
                Object.keys(AllBucketsWithPinPathCp[bucket]['pages']).map((page) => {
                    if (pinnedModules.indexOf(AllBucketsWithPinPathCp[bucket]['pages'][page].pinPath) > -1) {
                        AllBucketsWithPinPathCp[bucket]['pages'][page].pinned = true;
                    } else {
                        if (AllBucketsWithPinPathCp[bucket].pinned) {
                            //missingModulePaths holds paths of modules which are added new under a pinned bucket
                            missingModulesPaths.push(AllBucketsWithPinPathCp[bucket]['pages'][page].pinPath);
                            AllBucketsWithPinPathCp[bucket]['pages'][page].pinned = true;
                        }
                    }
                    //Check in subBucket's page if applicable
                    if (Object.prototype.hasOwnProperty.call(AllBucketsWithPinPathCp[bucket]['pages'][page], 'pages')) {
                        AllBucketsWithPinPathCp[bucket]['pages'][page]['pages'] = setBoolPinnedForBuckets(
                            pinnedModules,
                            AllBucketsWithPinPathCp[bucket]['pages'][page]['pages'],
                        );
                    }
                });
            }
        });
        return AllBucketsWithPinPathCp;
    };

    //Assign pinPaths to all modules and buckets
    const setBucketsWithPinPath = (bucketsLookupCpLocal, parentPath) => {
        Object.keys(bucketsLookupCpLocal).map((bucket) => {
            if (parentPath) {
                bucketsLookupCpLocal[bucket].pinPath = parentPath + '.' + bucket;
            } else {
                //Assigning pinPath to main buckets(they dont have parent path)
                if (!Object.prototype.hasOwnProperty.call(bucketsLookupCpLocal[bucket], 'pinPath')) {
                    bucketsLookupCpLocal[bucket]['pinPath'] = `${userInfo.currentMarket}.${bucket}.*`;
                }
            }

            //check for pages under buckets
            bucketsLookupCpLocal[bucket].pages &&
                Object.keys(bucketsLookupCpLocal[bucket].pages).map((page, id) => {
                    let pinPathLocal = '';
                    if (parentPath) {
                        //parent path is present in case of sub-buckets
                        pinPathLocal = parentPath + '.' + bucket;
                        bucketsLookupCpLocal[bucket].pages[page]['pinPath'] = parentPath + '.' + bucket;
                    } else {
                        if (
                            !Object.prototype.hasOwnProperty.call(bucketsLookupCpLocal[bucket].pages[page], 'pinPath')
                        ) {
                            pinPathLocal = `${userInfo.currentMarket}.${bucket}.${page}`;
                            bucketsLookupCpLocal[bucket].pages[page][
                                'pinPath'
                            ] = `${userInfo.currentMarket}.${bucket}.${page}`;
                        }
                    }
                    if (Object.prototype.hasOwnProperty.call(bucketsLookupCpLocal[bucket].pages[page], 'pages')) {
                        //If the current page is a sub-bucket,ie it still has modules nested within,add the * at the end of its pinPath
                        bucketsLookupCpLocal[bucket].pages[page]['pinPath'] =
                            bucketsLookupCpLocal[bucket].pages[page]['pinPath'] + '.*';
                        let subBucketInfoWithPinPath = setBucketsWithPinPath(
                            bucketsLookupCpLocal[bucket].pages[page].pages,
                            pinPathLocal,
                        );
                        bucketsLookupCpLocal[bucket].pages[page].pages = subBucketInfoWithPinPath;
                    }
                });
        });
        return bucketsLookupCpLocal;
    };
    const setBucketsWithPinningInfo = (bucketsLookupCpLocal, pinnedModules) => {
        let AllBucketsWithPinInfo = setBucketsWithPinPath(bucketsLookupCpLocal, '');
        AllBucketsWithPinInfo = setBoolPinnedForBuckets(pinnedModules, AllBucketsWithPinInfo);
        setBucketsLookupWithPin(AllBucketsWithPinInfo);
    };
    const traverseBucketToPinUnpin = (bucket, pinnedModulesForMarket, action) => {
        if (bucket && bucket['pages']) {
            Object.keys(bucket.pages).map((pg) => {
                const index = pinnedModulesForMarket.findIndex((page) => page === bucket['pages'][pg].pinPath);
                if (action == 'pinAction') {
                    if (index == -1 && bucket['pages'][pg].pinPath) {
                        pinnedModulesForMarket.push(bucket['pages'][pg].pinPath);
                    }
                } else {
                    if (index > -1) {
                        pinnedModulesForMarket.splice(index, 1);
                    }
                }
                if (bucket['pages'][pg]['pages'] && Object.keys(bucket['pages'][pg]['pages']).length > 0)
                    pinnedModulesForMarket = traverseBucketToPinUnpin(
                        bucket['pages'][pg],
                        pinnedModulesForMarket,
                        action,
                    );
            });
        }
        return pinnedModulesForMarket;
    };
    const pinCurrentModule = (bucket) => {
        if (!bucket || Object.keys(bucket).length == 0) return;
        setOnLoadPinUnpinAction(false);
        let pageKey = bucket.pinPath || currentPageKey;
        let preferences = localStorage.getItem(`ngStorage-preferences_${userInfo.loggedInUserName}`);
        preferences = preferences ? JSON.parse(preferences) : {};
        let pinnedModules = preferences.appHome ? preferences.appHome.pinnedModules || {} : {};
        let pinnedModulesForMarket = pinnedModules[userInfo.currentMarket] || [];
        const index = pinnedModulesForMarket.findIndex((page) => page === pageKey);
        if (Object.keys(bucket).length > 0) {
            pinnedModulesForMarket = traverseBucketToPinUnpin(bucket, pinnedModulesForMarket, 'pinAction');
        }
        if (index == -1) {
            pinnedModulesForMarket.push(pageKey);
            pinnedModules[userInfo.currentMarket] = pinnedModulesForMarket;
            setloading(true);
            setUserPreference({
                pageName: 'appHome',
                key: 'pinnedModules',
                value: pinnedModules,
            })
                .then((res) => {
                    getPinnedModules();
                    triggerUserPrefChange();
                })
                .finally(() => setloading(false));
        }
    };
    const unPinCurrentModule = (bucket, clearAll = false) => {
        if (!bucket || Object.keys(bucket).length == 0) return;
        let pageKey = bucket.pinPath || currentPageKey;
        setOnLoadPinUnpinAction(false);
        let preferences = localStorage.getItem(`ngStorage-preferences_${userInfo.loggedInUserName}`);
        preferences = preferences ? JSON.parse(preferences) : {};
        let pinnedModules = preferences.appHome ? preferences.appHome.pinnedModules || {} : {};
        let pinnedModulesForMarket = pinnedModules[userInfo.currentMarket] || [];
        if (bucket.pinPath) {
            let pgKey = bucket.pinPath;
            pgKey = pgKey.split('.');
            if (pgKey.length == 4 && pgKey[3] == '*') {
                pgKey = pgKey[0] + '.' + pgKey[1] + '.' + pgKey[3];
                let indexOfParent = pinnedModulesForMarket.findIndex((page) => page === pgKey);
                if (indexOfParent > -1) {
                    pinnedModulesForMarket.splice(indexOfParent, 1);
                }
            }
        }
        if (Object.keys(bucket).length > 0) {
            pinnedModulesForMarket = traverseBucketToPinUnpin(bucket, pinnedModulesForMarket, 'unpinAction');
        }
        let index = pinnedModulesForMarket.findIndex((page) => page === pageKey);

        //For unpinning parent buckets of a module when the module is being unpinned
        if (pageKey && pageKey[pageKey.length - 1] != '*') {
            //Check if the current bucket is actually a module
            console.log('current is a module');
            if (index > -1) {
                let pageKeyArray = pageKey.split('.');
                pageKeyArray = pageKeyArray.splice(0, pageKeyArray.length - 1);
                let ans = pageKeyArray[0];
                for (let i = 1; i < pageKeyArray.length; i++) {
                    ans = ans + '.' + pageKeyArray[i];
                    let ind = pinnedModulesForMarket.findIndex((page) => page == ans + '.*');
                    //Check if parent bucket/sub-bucket was pinned.If so,unpin those.
                    if (ind > -1) {
                        pinnedModulesForMarket.splice(ind, 1);
                    }
                }
            }
        }
        index = pinnedModulesForMarket.findIndex((page) => page === pageKey);
        if (index > -1) {
            pinnedModulesForMarket.splice(index, 1);
            pinnedModules[userInfo.currentMarket] = pinnedModulesForMarket;
            setloading(true);
            setUserPreference({
                pageName: 'appHome',
                key: 'pinnedModules',
                value: pinnedModules,
            })
                .then((res) => {
                    getPinnedModules();
                    triggerUserPrefChange();
                })
                .finally(() => setloading(false));
        }
        if (clearAll) {
            setloading(true);
            setUserPreference({
                pageName: 'appHome',
                key: 'pinnedModules',
                value: pinnedModules,
            })
                .then((res) => {
                    getPinnedModules();
                    triggerUserPrefChange();
                })
                .finally(() => setloading(false));
        }
    };
    const triggerUserPrefChange = () => {
        let preferences = localStorage.getItem(`ngStorage-preferences_${userInfo.loggedInUserName}`);
        preferences = preferences ? JSON.parse(preferences) : {};
        setUserPref(preferences);
    };
    const openMobileLeftNav = () => {
        let olderHeaderConfig = {
            ...headerConfig,
        };
        olderHeaderConfig['showLeftNavMobile'] = true;
        setHeaderConfig(olderHeaderConfig);
    };
    const unpinAll = () => {
        let preferences = localStorage.getItem(`ngStorage-preferences_${userInfo.loggedInUserName}`);
        preferences = preferences ? JSON.parse(preferences) : {};
        let pinnedModules = preferences.appHome ? preferences.appHome.pinnedModules || {} : {};
        pinnedModules[userInfo.currentMarket] = [];
        setloading(true);
        setUserPreference({
            pageName: 'appHome',
            key: 'pinnedModules',
            value: pinnedModules,
        })
            .then((res) => {
                getPinnedModules();
                triggerUserPrefChange();
            })
            .finally(() => setloading(false));
    };
    const openHelpDocs = () => window.open(`/helpDoc?page=${window.location.pathname}`);
    return (
        <div ref={wrapperRef} id="headerOutermost">
            {!hideNavigation ? (
                <LeftNavigation2
                    bucketsLookupWithPin={bucketsLookupWithPin}
                    pinModuleFunc={pinCurrentModule}
                    unpinFunc={unPinCurrentModule}
                    unpinAll={unpinAll}
                    pinnedBuckets={pinnedBuckets}
                ></LeftNavigation2>
            ) : null}
            {!hideNavigation && currentPage.contextualLSP ? (
                <StrideNavigation strideBuckets={bucketsLookupWithPin['stride'].pages} />
            ) : null}
            {!hideHeader ? (
                <div className={classes.grow} id="headerContainer">
                    <Toolbar className={style.toolbar}>
                        {windowWidth <= 425 ? (
                            <i className="icon-Menu-18 sct-icon" id="hamIcon" onClick={openMobileLeftNav}></i>
                        ) : (
                            ''
                        )}
                        <Typography className={classes.title} variant="h6" noWrap>
                            {t(title)}
                        </Typography>
                        {startQuickTour && (
                            <QuickTour
                                setStartQuickTour={setStartQuickTour}
                                startQuickTour={startQuickTour}
                                pathname={window.location.pathname}
                            />
                        )}
                        {currentPageKey && (
                            <div id="pinnedIconContainer" className={style.headerPinIcons}>
                                {pinnedModules &&
                                pinnedModules.length > 0 &&
                                pinnedModules.indexOf(currentPageKey) >= 0 ? (
                                    <i
                                        title="Unpin module"
                                        className={style.pinIcon + ' sct-icon icon-Pinned-w'}
                                        onClick={() => unPinCurrentModule(currentPage)}
                                    ></i>
                                ) : (
                                    <i
                                        title="Pin module"
                                        className={style.pinIcon + ' sct-icon icon-Pinw'}
                                        onClick={() => pinCurrentModule(currentPage)}
                                    ></i>
                                )}
                            </div>
                        )}
                    </Toolbar>

                    <div className={classes.header}>
                        {children}

                        {supportMenuItems && Object.keys(supportMenuItems).length > 0 ? (
                            <div>
                                <span
                                    id="supportOnHeader"
                                    aria-controls="simple-menu"
                                    aria-haspopup="true"
                                    className={classes.supportMenu}
                                    onClick={(event) => setAnchorEl(event.currentTarget)}
                                >
                                    <span>{t('support')}</span>
                                    {anchorEl ? <ExpandLess /> : <ExpandMore />}
                                </span>
                                <Menu
                                    className={classes.menu}
                                    disableAutoFocusItem={true}
                                    id="support-menu"
                                    anchorEl={anchorEl}
                                    keepMounted
                                    open={Boolean(anchorEl)}
                                    onClose={() => setAnchorEl(null)}
                                >
                                    {supportMenuItems.reportIssue ? (
                                        <MenuItem
                                            onClick={() => {
                                                toggleIssueReporter(true);
                                                setAnchorEl(null);
                                            }}
                                        >
                                            {t('reportIssue')}
                                        </MenuItem>
                                    ) : null}
                                    {supportMenuItems.helpDocs ? (
                                        <MenuItem
                                            onClick={() => {
                                                setAnchorEl(null);
                                                openHelpDocs();
                                            }}
                                        >
                                            {t('helpDocs')}
                                        </MenuItem>
                                    ) : null}
                                    {supportMenuItems.quickTour ? (
                                        <MenuItem
                                            onClick={() => {
                                                setStartQuickTour(true);
                                                setAnchorEl(null);
                                            }}
                                        >
                                            {t('quickTour')}
                                        </MenuItem>
                                    ) : null}
                                </Menu>
                            </div>
                        ) : null}

                        {/* {issueCollectorEnvSupport && issueCollector && <span className={classes.reportIssueLink} onClick={() => toggleIssueReporter(true)}>Report Issue</span>} */}

                        {(window.location.href.indexOf('localhost') > -1 ||
                            window.location.href.indexOf('walmartlabs') > -1) &&
                            window.location.href.indexOf('apphome') > -1 &&
                            cookies &&
                            cookies.get('auth-src') !== 'wire' && (
                                <div className={customClass.requestAccessButton}>
                                    <Button
                                        color="primary"
                                        onClick={() => {
                                            window.open('/mfe/access-manager/access-request', '_blank');
                                        }}
                                    >
                                        {t('requestGscopeAccess')}
                                    </Button>
                                </div>
                            )}

                        {hasNotificationBadge && (
                            <ErrorHandler>
                                <NotificationBadge
                                    modsWithNotifications={modsWithNotifications}
                                    notificationPreferences={notificationPreferences}
                                />
                            </ErrorHandler>
                        )}

                        {((serviceAction && serviceType) || (bulkActions && Object.keys(bulkActions).length > 0)) &&
                            hasEditPermission && (
                                <CustomToolTip title="Bulk Upload">
                                    <span
                                        id="bulkUploadIcon"
                                        className="sct-icon icon-Upload"
                                        onClick={showBulkUpload}
                                    />
                                </CustomToolTip>
                            )}

                        {currentPageFAQ && (
                            <CustomToolTip title="Help">
                                <span className="sct-icon icon-Help-18" onClick={redirectToConfluenceLink} />
                            </CustomToolTip>
                        )}

                        {/* <LanguageSelector /> */}
                    </div>

                    {((serviceAction && serviceType) || (bulkActions && Object.keys(bulkActions).length > 0)) &&
                        openBulkUploadDrawer && (
                            <BulkUpload
                                openDrawer={openBulkUploadDrawer}
                                handleClose={hideBulkUpload}
                                uploadHistory={uploadHistory}
                                updateUploadHistory={updateUploadHistory}
                                showTIDcolumn={showTIDcolumn}
                            />
                        )}
                </div>
            ) : null}
        </div>
    );
};
HeaderComponent.propTypes = {
    classes: PropTypes.shape({}).isRequired,
};
export default withStyles(HeaderComponentStyles)(HeaderComponent);
export { HeaderComponent };
